import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const stats = [
  { value: "5+", label: "内容频道" },
  { value: "30+", label: "精选作品" },
  { value: "7×24", label: "资讯更新" },
  { value: "HD", label: "高清体验" },
];

const notices = [
  {
    icon: "ri-information-line",
    title: "用户须知",
    content:
      "本平台为演示型影视门户，页面内所有影视作品、演员、评分、资讯均为虚构或中性示例数据，仅用于产品展示与体验，不代表任何真实影视内容。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权声明",
    content:
      "平台不提供真实视频播放与下载服务，页面中出现的“播放”功能仅为交互演示。所有图片、文案均为示例素材，如涉及第三方权益请联系我们处理。",
  },
  {
    icon: "ri-shield-check-line",
    title: "隐私说明",
    content:
      "本平台不收集用户个人信息，不设置登录注册与会员功能，浏览过程中产生的数据仅用于页面展示本身。",
  },
];

export default function About() {
  useDocumentMeta(
    "关于我们 - 芒果tv",
    "了解芒果tv 的平台定位、服务内容与联系方式。芒果tv 致力于为观众提供清晰、丰富、易用的影视观影导航体验。"
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <section className="mt-4 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="relative h-44 w-full overflow-hidden bg-foreground-950 md:h-60">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20warm%20media%20brand%20banner%20with%20abstract%20flowing%20orange%20and%20amber%20shapes%20over%20a%20dark%20gradient%20background%2C%20cinematic%20soft%20glow%2C%20premium%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20composition&width=1600&height=600&seq=mgtv-about-hero&orientation=landscape"
            alt="芒果tv 品牌背景图"
            title="芒果tv 综合影视平台"
            className="h-full w-full object-cover object-top opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/30" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10">
            <span className="inline-flex w-fit items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-mickey-fill" />
              关于芒果tv
            </span>
            <h1 className="mt-3 max-w-2xl font-heading text-2xl font-extrabold text-background-50 md:text-4xl">
              汇聚好内容，让每一次观影都轻松愉快
            </h1>
            <p className="mt-2 max-w-xl text-sm text-background-100/90">
              多频道内容、清晰分类与实时资讯，只为让观众更快找到想看的那一部。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 p-6 md:grid-cols-4 md:p-8">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg bg-background-100 p-4 text-center">
              <p className="font-heading text-2xl font-extrabold text-primary-600">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <i className="ri-building-2-line text-primary-600" />
          平台定位
        </h2>
        <p className="mt-4 text-sm leading-loose text-foreground-600 md:text-base">
          芒果tv 定位为一个集合电视剧、综艺、电影、动漫、纪录片等多频道视频展示与最新娱乐资讯的综合性影视平台。目标用户覆盖广泛的影视观众群体，包括追剧爱好者、综艺粉丝与电影影迷。
        </p>
        <p className="mt-3 text-sm leading-loose text-foreground-600 md:text-base">
          我们希望通过清晰的频道分类、多条件的智能筛选与便捷的关键字搜索，帮助用户快速浏览与筛选海量影视资源，同时提供丰富、权威的娱乐资讯浏览体验，营造专业且活泼的观影氛围。
        </p>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="rounded-lg bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
              丰富的内容矩阵
            </h3>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">
              覆盖五大内容频道，持续更新精选作品，满足不同类型观众的偏好。
            </p>
          </div>
          <div className="rounded-lg bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-600">
              <i className="ri-filter-3-line text-xl" />
            </span>
            <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
              贴心的筛选体验
            </h3>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">
              按类型、地区、年份与热度多维筛选，快速定位你想看的内容。
            </p>
          </div>
          <div className="rounded-lg bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-newspaper-line text-xl" />
            </span>
            <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
              及时的娱乐资讯
            </h3>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">
              追剧之外，第一时间掌握剧集、综艺与行业的娱乐动态。
            </p>
          </div>
        </div>
      </section>

      <section className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_360px]">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <i className="ri-file-list-3-line text-primary-600" />
            用户须知与版权声明
          </h2>
          <div className="mt-5 space-y-4">
            {notices.map((n) => (
              <div key={n.title} className="flex gap-3">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${n.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950">
                    {n.title}
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-500">{n.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <i className="ri-customer-service-2-line text-primary-600" />
            联系方式
          </h2>
          <div className="mt-5 space-y-4 text-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-mail-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">官方邮箱</p>
                <p className="text-foreground-900">service@mangotv-demo.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-phone-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">客服电话</p>
                <p className="text-foreground-900">400-000-0000（工作日 9:00-18:00）</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-map-pin-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">办公地址</p>
                <p className="text-foreground-900">示例省示例市芒果大厦 8 层</p>
              </div>
            </div>
          </div>
          <p className="mt-5 text-xs leading-relaxed text-foreground-400">
            以上联系方式为演示信息，仅供项目预览使用。
          </p>
          <Link
            to="/"
            className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </section>
    </div>
  );
}